import React from "react"
import { DiscussionEmbed } from "disqus-react"

const Comments = ({ title, slug }) => {
  const disqusConfig = {
    shortname: "investitori-ribelli",
    config: { identifier: slug, title },
  }
  return <DiscussionEmbed {...disqusConfig} />
}

export default Comments
